import { render, staticRenderFns } from "./main-section-reports.vue?vue&type=template&id=69b6cebd&scoped=true"
import script from "./main-section-reports.vue?vue&type=script&lang=js"
export * from "./main-section-reports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b6cebd",
  null
  
)

export default component.exports